function setCookie(cName, cValue, expDays) {
  const date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = cName + '=' + cValue + '; ' + expires + '; path=/';
}

function setRegionCookie(region) {
  setCookie('region', region, 90);
}

function setupRegionSelectors() {
  const regionSelectors = document.querySelectorAll('[data-region-selector]');

  for (let i = 0; i < regionSelectors.length; i++) {
    const selector = regionSelectors[i];

    selector.addEventListener('click', function (e) {
      e.preventDefault();
      const region = e.currentTarget.dataset.region;
      setRegionCookie(region);

      window.location = e.currentTarget.getAttribute('href');
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  setupRegionSelectors();
});
